import React from 'react';

import Skeleton, {
  SKELETON_SHAPES,
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';

import styles from './fundLetterStyles.scss';

const FundLetterLoading: React.FC<{
  isMobile: boolean;
}> = ({ isMobile }): React.ReactElement => (
  <>
    {[...Array(3)].map((_e, i) => (
      <div className={styles.navAnchor} key={`nav-anchor-loading-${i}`}>
        <div className={styles.headerContainer}>
          {isMobile ? (
            <Skeleton customClass={styles.skeletonRect} containerHeight={50} containerWidth={50} />
          ) : (
            <Skeleton containerHeight={75} shape={SKELETON_SHAPES.CIRCLE} containerWidth={75} />
          )}
        </div>
        <div className={styles.listContainer}>
          {[...Array(2)].map((_e, i) => (
            <div className={styles.fundLetterList} key={`letter-list-loading-${i}`}>
              <div className={styles.fundNameHeader}>
                <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} size={SKELETON_SIZES.LARGE} />
              </div>
              <div className={styles.linkList}>
                <Skeleton size={SKELETON_SIZES.SMALL} />
                <Skeleton size={SKELETON_SIZES.SMALL} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </>
);

export default FundLetterLoading;
